<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiInput from '../ui/Input';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiButton from '../ui/Button';
import UiTabs from '../ui/Tabs';
import UiHeadline from '../ui/Headline';
import UiLoading from '../ui/Loading';
import UiScrollbar from '../ui/Scrollbar';
import UiModal from '../ui/Modal';
import * as crossPopup from '../../functions/crossPopup';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiInput,
        UiSubheader,
        UiStepper,
        UiButton,
        UiTabs,
        UiHeadline,
        UiLoading,
        UiScrollbar,
        UiModal,
    },
    created() {
        crossPopup.closeAllInstances();
        if (this.isEditorAccount) {
            this.$router.push({name: 'home'});
        }
        this.setToolbarTitle('Media');
        this.fetchBubbles();
        this.fetchBanners();
        this.fetchNotificationImages();
        this.fetchAdvertisementImages();
        this.fetchExtendedBanners();
        this.fetchIosExtendedNotifications();
        this.fetchIosAppleWatchImages();
        this.fetchIosExtendedVisualNotifications();
        this.fetchStudioImages();
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    data() {
        return {
            uploadType: null,
            bubbles: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            banners: {
                items: [],
                loading: false,
                error: false,
            },
            notificationImage: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            advertisementImage: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            extendedBanner: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            iosExtendedNotification: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            iosAppleWatch: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            iosExtendedVisualNotification: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            studio: {
                items: [],
                loading: false,
                uploading: false,
                error: false,
                errorDuplicate: false,
            },
            modNews: {
                uploading: false,
                error: false,
                dialogVisible: false,
                fileAndroid: null,
                fileIOS: null,
            },
            modalDelete: {
                visible: false,
                loading: false,
                type: null,
                instance: null,
            },
            modalBannerEdit: {
                visible: false,
                loading: false,
                instance: null,
                modelUrl: '',
            },
            modalBannerNew: {
                visible: false,
                loading: false,
                error: false,
                title: '',
                url: '',
                image: null,
            },
            scrollY: 0,
        };
    },
    computed: {
        bubblesSorted() {
            const { items } = this.bubbles;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        bannersSorted() {
            const { items } = this.banners;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        notificationImageSorted() {
            const { items } = this.notificationImage;
            return items === null ? [] : items.filter(i => i.fileName.indexOf('android_modnewsbackground') === -1).sort((a, b) => b.id - a.id);
        },
        advertisementImageSorted() {
            const { items } = this.advertisementImage;
            return items === null ? [] : items.sort((a, b) => b.id - a.id).sort((a, b) => {
                if (a.backgroundFileName && b.backgroundFileName) return 0;
                if (!a.backgroundFileName && !b.backgroundFileName) return 0;
                if (a.backgroundFileName) return -1;
                if (b.backgroundFileName) return 1;
            });
        },
        extendedBannerSorted() {
            const { items } = this.extendedBanner;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        iosExtendedNotificationSorted() {
            const { items } = this.iosExtendedNotification;
            return items === null ? [] : items.filter(i => i.fileName.indexOf('ios_modnewsbackground') === -1).sort((a, b) => b.id - a.id);
        },
        iosAppleWatchSorted() {
            const { items } = this.iosAppleWatch;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        iosExtendedVisualNotificationSorted() {
            const { items } = this.iosExtendedVisualNotification;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        studioSorted() {
            const { items } = this.studio;
            return items === null ? [] : items.sort((a, b) => b.id - a.id);
        },
        modNewsSorted() {
            const { items: androidImages } = this.notificationImage;
            const { items: iosImages } = this.iosExtendedNotification;
            if (!androidImages || !iosImages) {
                return [];
            }
            const combined = {};
            androidImages.sort((a, b) => b.id - a.id).forEach(i => {
                if (i.fileName.indexOf('android_modnewsbackground') > -1) {
                    combined[i.fileName.split('_')[0]] = {
                        android: i,
                        ios: null,
                    };
                }
            });
            iosImages.forEach(i => {
                if (i.fileName.indexOf('ios_modnewsbackground') > -1 && combined[i.fileName.split('_')[0]]) {
                    combined[i.fileName.split('_')[0]]['ios'] = i;
                }
            });
            return Object.values(combined);
        },
        defaultBubble() {
            if (!this.userInfo || !this.userInfo.defaultLogo) {
                return null;
            }
            return sdk.getBubbleImage(this.userInfo.groupId, this.userInfo.defaultLogo);
        },
        isNewBannerReady() {
            const {
                title,
                url,
            } = this.modalBannerNew;
            return title && url;
        },
    },
    methods: {
        fetchBubbles() {
            this.bubbles.loading = true;
            sdk.pressengerControl.getSenderGroupId().then(gid => {
                sdk.pressengerControl.getNotificationLogos(gid).then(bubbles => {
                    this.bubbles.items = bubbles;
                    this.bubbles.loading = false;
                }).catch(() => {
                    setTimeout(() => {
                        this.fetchBubbles();
                    }, 1000);
                });
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchBubbles();
                    }
                }, 1000);
            });
        },
        fetchNotificationImages() {
            this.notificationImage.loading = true;
            sdk.pressengerControl.getNotificationImages().then(items => {
                this.notificationImage.items = items;
                this.notificationImage.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchNotificationImages();
                    }
                }, 1000);
            });
        },
        fetchAdvertisementImages() {
            this.advertisementImage.loading = true;
            sdk.pressengerControl.getAdvertisementImages().then(items => {
                this.advertisementImage.items = items;
                this.advertisementImage.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchAdvertisementImages();
                    }
                }, 1000);
            });
        },
        fetchExtendedBanners() {
            this.extendedBanner.loading = true;
            sdk.pressengerControl.getExtendedNotificationImages().then(items => {
                this.extendedBanner.items = items;
                this.extendedBanner.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchExtendedBanners();
                    }
                }, 1000);
            });
        },
        fetchIosExtendedNotifications() {
            this.iosExtendedNotification.loading = true;
            sdk.pressengerControl.getiOSLogos().then(items => {
                this.iosExtendedNotification.items = items.filter(i => i.fileName.indexOf('-2nd') === -1);
                this.iosExtendedNotification.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchIosExtendedNotifications();
                    }
                }, 1000);
            });
        },
        fetchIosAppleWatchImages() {
            this.iosAppleWatch.loading = true;
            sdk.pressengerControl.getiOSWatchImages().then(items => {
                this.iosAppleWatch.items = items;
                this.iosAppleWatch.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchIosAppleWatchImages();
                    }
                }, 1000);
            });
        },
        fetchIosExtendedVisualNotifications() {
            this.iosExtendedVisualNotification.loading = true;
            sdk.pressengerControl.getiOSLogos().then(items => { // TODO: replace endpoint
                this.iosExtendedVisualNotification.items = items.filter(i => i.fileName.indexOf('-2nd') > -1);
                this.iosExtendedVisualNotification.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchIosExtendedVisualNotifications();
                    }
                }, 1000);
            });
        },
        fetchBanners(edit = false) {
            this.banners.loading = true;
            sdk.pressengerControl.listBrandPics().then(banners => {
                this.banners.items = banners;
                this.banners.loading = false;
                if (edit) {
                    this.showModalBannerEdit(this.bannersSorted[0]);
                }
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchBanners();
                    }
                }, 1000);
            });
        },
        fetchStudioImages() {
            this.studio.loading = true;
            sdk.pressengerControl.getStudioImages().then(items => {
                this.studio.items = items;
                this.studio.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    if (!this._isDestroyed) {
                        this.fetchStudioImages();
                    }
                }, 1000);
            });
        },
        upload(type) {
            this.uploadType = type;
            this.$refs.uploader.click();
        },
        startUpload(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return
            }
            const fnClean = files[0].name.replace(/[^\w.-]+/g, '_');
            const image = new File([files[0]], this.uploadType === 'iosExtendedVisualNotification' ? `${Date.now()}-2nd-${fnClean}` : `${Date.now()}-${fnClean}`);
            switch(this.uploadType) {
                case 'bubble':
                    this.bubbles.error = false;
                    this.bubbles.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.bubbles.items)) {
                        this.bubbles.error = true;
                        this.bubbles.errorDuplicate = true;
                        return;
                    }
                    this.bubbles.uploading = true;
                    sdk.pressengerControl.uploadNotificationLogo(image).then(bubble => {
                        // server return null here O.o
                        this.bubbles.items.push(bubble);
                        this.fetchBubbles();
                    }).catch(() => {
                        this.bubbles.error = true;
                    }).finally(() => {
                        this.bubbles.uploading = false;
                    });
                    break;
                case 'notificationImage':
                    this.notificationImage.error = false;
                    this.notificationImage.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.notificationImage.items)) {
                        this.notificationImage.error = true;
                        this.notificationImage.errorDuplicate = true;
                        return;
                    }
                    this.notificationImage.uploading = true;
                    sdk.pressengerControl.uploadNotificationImage(image).then(item => {
                        this.notificationImage.items.push(item);
                    }).catch(() => {
                        this.notificationImage.error = true;
                    }).finally(() => {
                        this.notificationImage.uploading = false;
                    });
                    break;
                case 'advertisementImage':
                    this.advertisementImage.error = false;
                    this.advertisementImage.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.advertisementImage.items)) {
                        this.advertisementImage.error = true;
                        this.advertisementImage.errorDuplicate = true;
                        return;
                    }
                    this.advertisementImage.uploading = true;
                    sdk.pressengerControl.uploadAdvertisementImage(image).then(item => {
                        this.advertisementImage.items.push(item);
                    }).catch(() => {
                        this.advertisementImage.error = true;
                    }).finally(() => {
                        this.advertisementImage.uploading = false;
                    });
                    break;
                case 'extendedBanner':
                    this.extendedBanner.error = false;
                    this.extendedBanner.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.extendedBanner.items)) {
                        this.extendedBanner.error = true;
                        this.extendedBanner.errorDuplicate = true;
                        return;
                    }
                    this.extendedBanner.uploading = true;
                    sdk.pressengerControl.uploadExtendedNotificationImage(image).then(item => {
                        this.extendedBanner.items.push(item);
                    }).catch(() => {
                        this.extendedBanner.error = true;
                    }).finally(() => {
                        this.extendedBanner.uploading = false;
                    });
                    break;
                case 'iosExtendedNotification':
                    this.iosExtendedNotification.error = false;
                    this.iosExtendedNotification.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.iosExtendedNotification.items)) {
                        this.iosExtendedNotification.error = true;
                        this.iosExtendedNotification.errorDuplicate = true;
                        return;
                    }
                    this.iosExtendedNotification.uploading = true;
                    sdk.pressengerControl.uploadiOSLogo(image).then(item => {
                        this.iosExtendedNotification.items.push(item);
                    }).catch(() => {
                        this.iosExtendedNotification.error = true;
                    }).finally(() => {
                        this.iosExtendedNotification.uploading = false;
                    });
                    break;
                case 'iosAppleWatch':
                    this.iosAppleWatch.error = false;
                    this.iosAppleWatch.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.iosAppleWatch.items)) {
                        this.iosAppleWatch.error = true;
                        this.iosAppleWatch.errorDuplicate = true;
                        return;
                    }
                    this.iosAppleWatch.uploading = true;
                    sdk.pressengerControl.uploadiOSWatchImage(image).then(item => {
                        this.iosAppleWatch.items.push(item);
                    }).catch(() => {
                        this.iosAppleWatch.error = true;
                    }).finally(() => {
                        this.iosAppleWatch.uploading = false;
                    });
                    break;
                case 'iosExtendedVisualNotification':
                    this.iosExtendedVisualNotification.error = false;
                    this.iosExtendedVisualNotification.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.iosExtendedVisualNotification.items)) {
                        this.iosExtendedVisualNotification.error = true;
                        this.iosExtendedVisualNotification.errorDuplicate = true;
                        return;
                    }
                    this.iosExtendedVisualNotification.uploading = true;
                    sdk.pressengerControl.uploadiOSLogo(image).then(item => { // TODO: replace endpoint
                        this.iosExtendedVisualNotification.items.push(item);
                    }).catch(() => {
                        this.iosExtendedVisualNotification.error = true;
                    }).finally(() => {
                        this.iosExtendedVisualNotification.uploading = false;
                    });
                    break;
                case 'studio':
                    this.studio.error = false;
                    this.studio.errorDuplicate = false;
                    if (this.checkIsDuplicateFilename(files[0].name, this.studio.items)) {
                        this.studio.error = true;
                        this.studio.errorDuplicate = true;
                        return;
                    }
                    this.studio.uploading = true;
                    sdk.pressengerControl.uploadStudioImage(image).then(item => {
                        this.studio.items.push(item);
                    }).catch(() => {
                        this.studio.error = true;
                    }).finally(() => {
                        this.studio.uploading = false;
                    });
                    break;
            }
        },
        pickModNewsBackground(event, device) {
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return;
            }
            switch (device) {
                case 'android':
                    this.modNews.fileAndroid = files[0];
                    break;
                case 'ios':
                    this.modNews.fileIOS = files[0];
                    break;
            }
            this.$refs.modNewsAndroidUploader.value = null;
            this.$refs.modNewsIOSUploader.value = null;
        },
        uploadModNewsBackgrounds() {
            this.modNews.uploading = true;
            const timestamp = Date.now();
            const androidFilename = `${timestamp}_android_modnewsbackground.${this.modNews.fileAndroid.name.split('.').pop()}`;
            const iosFilename = `${timestamp}_ios_modnewsbackground.${this.modNews.fileIOS.name.split('.').pop()}`;
            Promise.all([
                sdk.pressengerControl.uploadNotificationImage(new File([this.modNews.fileAndroid], androidFilename)),
                sdk.pressengerControl.uploadiOSLogo(new File([this.modNews.fileIOS], iosFilename)),
            ]).then(values => {
                this.notificationImage.items.push(values[0]);
                this.iosExtendedNotification.items.push(values[1]);
            }).catch(() => {
                this.modNews.error = true;
            }).finally(() => {
                this.modNews.uploading = false;
                this.modNews.dialogVisible = false;
            });
        },
        toggleSelected(arr, id) {
            const pos = arr.selected.indexOf(id);
            if (pos === -1) {
                arr.selected.push(id);
            } else {
                arr.selected.splice(pos, 1);
            }
        },
        setDefaultBubble(id) {
            const bubble = this.bubbles.items.find(i => i.id === id);
            sdk.pressengerControl.setDefaultLogo(bubble.fileName).then(() => {
                this.setUserInfo(Object.assign({}, this.userInfo, {
                    defaultLogo: bubble.fileName,
                }));
            });
        },
        isBubbleMP4(bubble) {
            return bubble.fileName.split('.').pop().toLowerCase() === 'mp4';
        },
        isIOSExtendedNotificationMP4(item) {
            return item.fileName.split('.').pop().toLowerCase() === 'mp4';
        },
        isIOSExtendedVisualNotificationMP4(item) {
            return item.fileName.split('.').pop().toLowerCase() === 'mp4';
        },
        getBubbleImage(bubble) {
            return sdk.getBubbleImage(bubble.groupId, bubble.fileName);
        },
        getNotificationImageSrc(i) {
            return sdk.getNotificationImageURL(i.groupId, i.fileName);
        },
        getAdvertisementImageSrc(i) {
            if (i.backgroundFileName) {
                return sdk.getAdvertisementImageBigURL(i.groupId, i.fileName);
            } else {
                return sdk.getAdvertisementImageURL(i.groupId, i.fileName);
            }
        },
        getExtendedBannerSrc(i) {
            return sdk.getExtendedBannerURL(i.groupId, i.fileName);
        },
        getIosExtendedNotificationSrc(i) {
            return sdk.getIOSExtendedNotificationURL(i.groupId, i.fileName);
        },
        getIosAppleWatchSrc(i) {
            return sdk.getIOSAppleWatchURL(i.groupId, i.fileName);
        },
        getIosExtendedVisualNotificationSrc(i) {
            return sdk.getIOSExtendedNotificationURL(i.groupId, i.fileName); // TODO: replace endpoint
        },
        getStudioImageSrc(i) {
            return sdk.getStudioImageURL(i.groupId, i.fileName);
        },
        showModalDelete(type, instance) {
            this.modalDelete.type = type;
            this.modalDelete.instance = instance;
            this.modalDelete.visible = true;
        },
        hideModalDelete() {
            this.modalDelete.type = null;
            this.modalDelete.instance = null;
            this.modalDelete.visible = false;
        },
        executeModalDelete() {
            const { type, instance } = this.modalDelete;
            let promise = null;
            switch(type) {
                case 'bubble':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteNotificationLogo(instance.fileName);
                    promise.then(() => {
                        this.bubbles.items = this.bubbles.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'notificationImage':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteNotificationImage(instance.fileName);
                    promise.then(() => {
                        this.notificationImage.items = this.notificationImage.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'advertisementImage':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteAdvertisementImage(instance.fileName);
                    promise.then(() => {
                        this.advertisementImage.items = this.advertisementImage.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'extendedBanner':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteExtendedNotificationImage(instance.fileName);
                    promise.then(() => {
                        this.extendedBanner.items = this.extendedBanner.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'iosExtendedNotification':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteiOSLogo(instance.fileName);
                    promise.then(() => {
                        this.iosExtendedNotification.items = this.iosExtendedNotification.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'iosAppleWatch':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteiOSWatchImage(instance.fileName);
                    promise.then(() => {
                        this.iosAppleWatch.items = this.iosAppleWatch.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'iosExtendedVisualNotification':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteiOSLogo(instance.fileName); // TODO: replace endpoint
                    promise.then(() => {
                        this.iosExtendedVisualNotification.items = this.iosExtendedVisualNotification.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'banner':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteBrandPicById(instance.id);
                    promise.then(() => {
                        this.banners.items = this.banners.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'studio':
                    this.modalDelete.loading = true;
                    promise = sdk.pressengerControl.deleteStudioImage(instance.fileName);
                    promise.then(() => {
                        this.studio.items = this.studio.items.filter(i => i.id !== instance.id);
                    });
                    break;
                case 'modnews':
                    this.modalDelete.loading = true;
                    const promise1 = sdk.pressengerControl.deleteNotificationImage(instance.android.fileName);
                    promise1.then(() => {
                        this.notificationImage.items = this.notificationImage.items.filter(i => i.id !== instance.android.id);
                    });
                    const promise2 = sdk.pressengerControl.deleteiOSLogo(instance.ios.fileName);
                    promise2.then(() => {
                        this.iosExtendedNotification.items = this.iosExtendedNotification.items.filter(i => i.id !== instance.ios.id);
                    });
                    promise = Promise.all([promise1, promise2]);
                    break;
            }
            promise.then(() => {
                this.hideModalDelete();
            }).finally(() => {
                this.modalDelete.loading = false;
            });
        },
        showModalBannerEdit(instance) {
            this.modalBannerEdit.instance = instance;
            this.modalBannerEdit.visible = true;
            this.modalBannerEdit.modelUrl = instance.link;
        },
        hideModalBannerEdit() {
            this.modalBannerEdit.instance = null;
            this.modalBannerEdit.visible = false;
            this.modalBannerEdit.modelUrl = '';
        },
        executeModalBannerEdit() {
            this.modalBannerEdit.loading = true;
            sdk.pressengerControl.setBrandPicLinkById(
                this.modalBannerEdit.instance.id,
                this.modalBannerEdit.modelUrl,
            ).then(() => {
                this.hideModalBannerEdit();
                this.fetchBanners();
            }).finally(() => {
                this.modalBannerEdit.loading = false;
            });
        },
        showModalBannerNew() {
            this.modalBannerNew.visible = true;
            this.modalBannerNew.image = null;
            this.modalBannerNew.title = '';
            this.modalBannerNew.url = '';
        },
        hideModalBannerNew() {
            this.modalBannerNew.visible = false;
        },
        executeModalBannerNew() {
            this.modalBannerNew.error = false;
            this.modalBannerNew.loading = true;
            sdk.pressengerControl.uploadBrandPic(
                this.modalBannerNew.image,
                this.modalBannerNew.url,
                this.modalBannerNew.title,
            ).then(banner => {
                // server return null here O.o
                // this.banners.items.push(banner);
                this.fetchBanners(false);
                this.hideModalBannerNew();
            }).catch(() => {
                this.modalBannerNew.error = true;
            }).finally(() => {
                this.modalBannerNew.loading = false;
            });
        },
        onBannerPicked(event) {
            const files = event.target.files || event.dataTransfer.files;
            if (files[0]) {
                this.modalBannerNew.image = files[0];
            }
        },
        friendlyName(filename, trimExt = true) {
            if (filename === null) {
                return 'ERROR';
            }
            let name = filename;
            const prefix = name.match(/^[0-9]+-/gi);
            const ext = name.match(/.[a-z]+$/gi);
            if (prefix) {
                name = name.substring(prefix[0].length);
            }
            if (trimExt, ext) {
                name = name.substring(0, name.length - ext[0].length)
            }
            return name;
        },
        checkIsDuplicateFilename(filename, items) {
            const ffn = this.friendlyName(filename)
            return !!items.find(i => this.friendlyName(i.fileName) === ffn);
        },
        scrollTo(elId) {
            if (elId) {
                window.scroll(0, document.getElementById(elId).offsetTop - 130);
            } else {
                window.scroll(0, 0);
            }
        },
        handleScroll() {
            this.scrollY = window.scrollY;
        },
        copyToClipboard(text) {
            const tempInput = document.createElement('textarea');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
        },
    },
}
</script>

<template>
    <ui-container>
        <ui-modal :visible="modalDelete.visible">
            <ui-headline class="small mt-0">{{ $t('mediaView.deleteTitle') }}</ui-headline>
            <div class="mb-3" v-html="$t('mediaView.deleteBody')" />
            <div class="FlexRow JustifyEnd">
                <ui-button @click.native="hideModalDelete()" :disabled="modalDelete.loading" class="primary white">{{ $t('mediaView.deleteNo') }}</ui-button>
                <ui-button @click.native="executeModalDelete()" :disabled="modalDelete.loading" class="primary white ml-1">{{ $t('mediaView.deleteYes') }}</ui-button>
            </div>
        </ui-modal>
        <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            @change="startUpload"
            style="display: none"
        />
        <ui-headline>{{ $t('mediaView.pageTitle') }}</ui-headline>
        <nav class="SubNav">
            <template v-if="!isIOSOnly">
                <a href="javascript:;" @click="scrollTo('section-notificationImage')">
                    {{ $t('mediaView.notificationImageSubtitle') }}
                    <span class="mdi mdi-android"></span>
                </a>
                <a href="javascript:;" @click="scrollTo('section-advertisementImage')">
                    {{ $t('mediaView.advertisementImageSubtitle') }}
                    <span class="mdi mdi-android"></span>
                </a>
                <template v-if="isAndroidExtBannerEnabled">
                    <a href="javascript:;" @click="scrollTo('section-extendedBanner')">
                        {{ $t('mediaView.extendedBannerSubtitle') }}
                        <span class="mdi mdi-android"></span>
                    </a>
                </template>
                <template v-if="!userInfo.disableBubble">
                    <a href="javascript:;" @click="scrollTo('section-bubbles')">
                        {{ $t('mediaView.bubblesSubtitle') }}
                        <span class="mdi mdi-android"></span>
                    </a>
                </template>
            </template>
            <template v-if="!isAndroidOnly">
                <a href="javascript:;" @click="scrollTo('section-iosExtendedNotification')">
                    {{ $t('mediaView.iosExtendedNotificationSubtitle') }}
                    <span class="mdi mdi-apple"></span>
                </a>
                <a href="javascript:;" @click="scrollTo('section-iosAppleWatch')">
                    {{ $t('mediaView.iosAppleWatchSubtitle') }}
                    <span class="mdi mdi-apple"></span>
                </a>
                <a href="javascript:;" @click="scrollTo('section-iosExtendedVisualNotification')" v-if="isIOSExtVisualNotificationEnabled">
                    {{ $t('mediaView.iosExtendedVisualNotificationSubtitle') }}
                    <span class="mdi mdi-apple"></span>
                </a>
            </template>
            <template v-if="userInfo.brandOwner">
                <a href="javascript:;" @click="scrollTo('section-banners')">
                    {{ $t('mediaView.bannersSubtitle') }}
                </a>
            </template>
            <template v-if="!userInfo.disableBubble">
                <a href="javascript:;" @click="scrollTo('section-studio')">
                    {{ $t('mediaView.studioSubtitle') }}
                </a>
            </template>
            <template v-if="isModNewsEnabled">
                <a href="javascript:;" @click="scrollTo('section-modNews')">
                    {{ $t('mediaView.modNewsSubtitle') }}
                </a>
            </template>
        </nav>
        <div class="NavTop" @click="scrollTo()" :style="{opacity: Math.min(100, scrollY - 50) / 100}">
            <svg viewBox="0 0 487 487">
                <path d="M397.7,376.1c20.4,20.4,53.6,20.4,74,0s20.4-53.6,0-74L280.5,110.9c-20.4-20.4-53.6-20.4-74,0L15.3,302.1c-20.4,20.4-20.4,53.6,0,74s53.6,20.4,74,0l154.2-154.2L397.7,376.1z"/>
            </svg>
        </div>
        <template v-if="!isIOSOnly">
            <ui-subheader id="section-notificationImage">{{ $t('mediaView.notificationImageSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: notificationImage.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.notificationImageTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: notificationImage.error}" v-html="$t('mediaView.notificationImageBody')" />
                            <div v-if="notificationImage.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                            <div class="ButtonWrapper">
                                <ui-button @click.native="upload('notificationImage')" type="primary white" :disabled="notificationImage.uploading || notificationImage.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="notificationImage.loading" />
                    <ui-scrollbar v-else-if="notificationImageSorted.length">
                        <div class="Grid GridToolbarAlt GridSingle">
                            <div
                                v-for="i in notificationImageSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('notificationImage', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper">
                                    <img :src="getNotificationImageSrc(i)" />
                                </div>
                                <div class="ItemTitle">
                                    <span>{{ friendlyName(i.fileName) }}</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="Divider"></div>
            <ui-subheader id="section-advertisementImage">{{ $t('mediaView.advertisementImageSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: advertisementImage.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.advertisementImageTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: advertisementImage.error}" v-html="$t('mediaView.advertisementImageBody')" />
                            <div v-if="advertisementImage.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                            <div class="ButtonWrapper">
                                <ui-button @click.native="upload('advertisementImage')" type="primary white" :disabled="advertisementImage.uploading || advertisementImage.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="advertisementImage.loading" />
                    <ui-scrollbar v-else-if="advertisementImageSorted.length">
                        <div class="Grid GridToolbarAlt GridSingle">
                            <div
                                v-for="i in advertisementImageSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('advertisementImage', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper AddNoise">
                                    <img :src="getAdvertisementImageSrc(i)" />
                                </div>
                                <div class="ItemTitle">
                                    <span>{{ friendlyName(i.fileName) }}</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <template v-if="isAndroidExtBannerEnabled">
                <div class="Divider"></div>
                <ui-subheader id="section-extendedBannerSubtitle">{{ $t('mediaView.extendedBannerSubtitle') }}</ui-subheader>
                <div :class="['Panel', {Loading: extendedBanner.uploading}]">
                    <div class="Left">
                        <ui-headline class="small">
                            <span v-html="$t('mediaView.extendedBannerTitle')" />
                        </ui-headline>
                        <div class="Content">
                            <div class="Upload">
                                <div :class="{Info: true, Error: extendedBanner.error}" v-html="$t('mediaView.extendedBannerBody')" />
                                <div v-if="extendedBanner.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                                <div class="ButtonWrapper">
                                    <ui-button @click.native="upload('extendedBanner')" type="primary white" :disabled="extendedBanner.uploading || extendedBanner.loading">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                        {{ $t('mediaView.upload') }}
                                    </ui-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Right">
                        <ui-loading v-if="extendedBanner.loading" />
                        <ui-scrollbar v-else-if="extendedBannerSorted.length">
                            <div class="Grid">
                                <div
                                    v-for="i in extendedBannerSorted"
                                    class="GridItem"
                                    :key="i.id"
                                    @click="copyToClipboard(i.fileName)"
                                >
                                    <div class="Toolbar">
                                        <a href="javascript:;" @click.stop="showModalDelete('extendedBanner', i)">
                                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                        </a>
                                    </div>
                                    <div class="ImageWrapper">
                                        <img :src="getExtendedBannerSrc(i)" />
                                    </div>
                                    <div class="ItemTitle">
                                        <span>{{ friendlyName(i.fileName) }}</span>
                                    </div>
                                </div>
                            </div>
                        </ui-scrollbar>
                        <span v-else>{{ $t('mediaView.noResults') }}</span>
                    </div>
                    <div class="LoadingOverlay">
                        <ui-loading />
                    </div>
                </div>
            </template>
            <template v-if="!userInfo.disableBubble">
                <div class="Divider"></div>
                <ui-subheader id="section-bubbles">{{ $t('mediaView.bubblesSubtitle') }}</ui-subheader>
                <div :class="['Panel', {Loading: bubbles.uploading}]">
                    <div class="Left">
                        <ui-headline class="small">
                            <span v-html="$t('mediaView.bubblesTitle')" />
                        </ui-headline>
                        <div class="Content">
                            <!--
                            <div class="Thumbnail">
                                <div class="ImageWrapper">
                                    <ui-loading v-if="bubbles.uploading" />
                                    <img v-else-if="defaultBubble" :src="defaultBubble" alt="" />
                                    <span v-else>{{ $t('mediaView.imageNone') }}</span>
                                </div>
                            </div>
                            -->
                            <div class="Upload">
                                <div :class="{Info: true, Error: bubbles.error}" v-html="$t('mediaView.bubblesBody')" />
                                <div v-if="bubbles.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                                <div class="ButtonWrapper">
                                    <ui-button @click.native="upload('bubble')" :disabled="bubbles.uploading || bubbles.loading" type="primary white">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                        {{ $t('mediaView.upload') }}
                                    </ui-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Right">
                        <ui-loading v-if="bubbles.loading" />
                        <ui-scrollbar v-else-if="bubblesSorted.length">
                            <div class="Grid GridToolbarAlt">
                                <div
                                    v-for="i in bubblesSorted"
                                    class="GridItem"
                                    :key="i.id"
                                    @click="copyToClipboard(i.fileName)"
                                >
                                    <div class="Toolbar">
                                        <!--
                                        <a href="javascript:;" @click="setDefaultBubble(i.id)" :class="{Active: i.fileName === userInfo.defaultLogo}">
                                            <i class="mdi mdi-star"></i>
                                        </a>
                                        -->
                                        <a href="javascript:;" @click.stop="showModalDelete('bubble', i)">
                                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                        </a>
                                    </div>
                                    <div class="ImageWrapper">
                                        <video v-if="isBubbleMP4(i)" autoplay loop>
                                            <source :src="getBubbleImage(i)" type="video/mp4">
                                            <span>Video not supported.</span>
                                        </video>
                                        <img v-else :src="getBubbleImage(i)" />
                                    </div>
                                    <div class="ItemTitle">
                                        <span>{{ friendlyName(i.fileName) }}</span>
                                    </div>
                                </div>
                            </div>
                        </ui-scrollbar>
                        <span v-else>{{ $t('mediaView.noResults') }}</span>
                    </div>
                    <div class="LoadingOverlay">
                        <ui-loading />
                    </div>
                </div>
            </template>
        </template>
        <template v-if="!isAndroidOnly">
            <div class="Divider"></div>
            <ui-subheader id="section-iosExtendedNotification">{{ $t('mediaView.iosExtendedNotificationSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: iosExtendedNotification.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.iosExtendedNotificationTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: iosExtendedNotification.error}" v-html="$t('mediaView.iosExtendedNotificationBody')" />
                            <div v-if="iosExtendedNotification.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                            <div class="ButtonWrapper">
                                <ui-button @click.native="upload('iosExtendedNotification')" type="primary white" :disabled="iosExtendedNotification.uploading || iosExtendedNotification.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="iosExtendedNotification.loading" />
                    <ui-scrollbar v-else-if="iosExtendedNotificationSorted.length">
                        <div class="Grid">
                            <div
                                v-for="i in iosExtendedNotificationSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('iosExtendedNotification', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper">
                                    <video v-if="isIOSExtendedNotificationMP4(i)" autoplay loop>
                                        <source :src="getIosExtendedNotificationSrc(i)" type="video/mp4">
                                        <span>Video not supported.</span>
                                    </video>
                                    <img v-else :src="getIosExtendedNotificationSrc(i)" />
                                </div>
                                <div class="ItemTitle">
                                    <span>{{ friendlyName(i.fileName) }}</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="Divider"></div>
            <ui-subheader id="section-iosAppleWatch">{{ $t('mediaView.iosAppleWatchSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: iosAppleWatch.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.iosAppleWatchTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: iosAppleWatch.error}" v-html="$t('mediaView.iosAppleWatchBody')" />
                            <div v-if="iosAppleWatch.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                            <div class="ButtonWrapper">
                                <ui-button @click.native="upload('iosAppleWatch')" type="primary white" :disabled="iosAppleWatch.uploading || iosAppleWatch.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="iosAppleWatch.loading" />
                    <ui-scrollbar v-else-if="iosAppleWatchSorted.length">
                        <div class="Grid">
                            <div
                                v-for="i in iosAppleWatchSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('iosAppleWatch', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper">
                                    <img :src="getIosAppleWatchSrc(i)" />
                                </div>
                                <div class="ItemTitle">
                                    <span>{{ friendlyName(i.fileName) }}</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <template v-if="isIOSExtVisualNotificationEnabled">
                <div class="Divider"></div>
                <ui-subheader id="section-iosExtendedVisualNotification">{{ $t('mediaView.iosExtendedVisualNotificationSubtitle') }}</ui-subheader>
                <div :class="['Panel', {Loading: iosExtendedVisualNotification.uploading}]">
                    <div class="Left">
                        <ui-headline class="small">
                            <span v-html="$t('mediaView.iosExtendedVisualNotificationTitle')" />
                        </ui-headline>
                        <div class="Content">
                            <div class="Upload">
                                <div :class="{Info: true, Error: iosExtendedVisualNotification.error}" v-html="$t('mediaView.iosExtendedVisualNotificationBody')" />
                                <div v-if="iosExtendedVisualNotification.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                                <div class="ButtonWrapper">
                                    <ui-button @click.native="upload('iosExtendedVisualNotification')" type="primary white" :disabled="iosExtendedVisualNotification.uploading || iosExtendedVisualNotification.loading">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                        {{ $t('mediaView.upload') }}
                                    </ui-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Right">
                        <ui-loading v-if="iosExtendedVisualNotification.loading" />
                        <ui-scrollbar v-else-if="iosExtendedVisualNotificationSorted.length">
                            <div class="Grid">
                                <div
                                    v-for="i in iosExtendedVisualNotificationSorted"
                                    class="GridItem"
                                    :key="i.id"
                                    @click="copyToClipboard(i.fileName)"
                                >
                                    <div class="Toolbar">
                                        <a href="javascript:;" @click.stop="showModalDelete('iosExtendedVisualNotification', i)">
                                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                        </a>
                                    </div>
                                    <div class="ImageWrapper">
                                        <video v-if="isIOSExtendedVisualNotificationMP4(i)" autoplay loop>
                                            <source :src="getIosExtendedVisualNotificationSrc(i)" type="video/mp4">
                                            <span>Video not supported.</span>
                                        </video>
                                        <img v-else :src="getIosExtendedVisualNotificationSrc(i)" />
                                    </div>
                                    <div class="ItemTitle">
                                        <span>{{ friendlyName(i.fileName) }}</span>
                                    </div>
                                </div>
                            </div>
                        </ui-scrollbar>
                        <span v-else>{{ $t('mediaView.noResults') }}</span>
                    </div>
                    <div class="LoadingOverlay">
                        <ui-loading />
                    </div>
                </div>
            </template>
        </template>
        <template v-if="userInfo.brandOwner">
            <div class="Divider"></div>
            <ui-subheader id="section-banners">{{ $t('mediaView.bannersSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: banners.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.bannersTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: banners.error}" v-html="$t('mediaView.bannersBody')" />
                            <div class="ButtonWrapper">
                                <ui-button @click.native="showModalBannerNew()" type="primary white">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="banners.loading" />
                    <ui-scrollbar v-else-if="bannersSorted.length">
                        <div class="Grid GridToolbarAlt GridSingle">
                            <div
                                v-for="i in bannersSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <div class="Text">
                                        <span>{{ i.title }}</span>
                                    </div>
                                    <a href="javascript:;" @click="showModalBannerEdit(i)">
                                        <i class="mdi mdi-wrench"></i>
                                    </a>
                                    <a href="javascript:;" @click.stop="showModalDelete('banner', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper">
                                    <img v-if="i.url" :src="i.url" />
                                    <iframe v-else :src="i.link" scrolling="no" sandbox="allow-scripts allow-same-origin" />
                                    <div class="Overlay">
                                        <div class="OverlayContent">
                                            <span>{{ i.link }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
        </template>
        <template v-if="!userInfo.disableBubble">
            <div class="Divider"></div>
            <ui-subheader id="section-studio">{{ $t('mediaView.studioSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: studio.uploading}]">
                <div class="Left">
                    <ui-headline class="small">
                        <span v-html="$t('mediaView.studioTitle')" />
                    </ui-headline>
                    <div class="Content">
                        <div class="Upload">
                            <div :class="{Info: true, Error: studio.error}" v-html="$t('mediaView.studioBody')" />
                            <div v-if="studio.errorDuplicate" class="Info Error">{{ $t('mediaView.errorDuplicateFilename') }}</div>
                            <div class="ButtonWrapper">
                                <ui-button @click.native="upload('studio')" type="primary white" :disabled="studio.uploading || studio.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.upload') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="studio.loading" />
                    <ui-scrollbar v-else-if="studioSorted.length">
                        <div class="Grid">
                            <div
                                v-for="i in studioSorted"
                                class="GridItem"
                                :key="i.id"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('studio', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper">
                                    <img :src="getStudioImageSrc(i)" />
                                </div>
                                <div class="ItemTitle">
                                    <span>{{ friendlyName(i.fileName) }}</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
        </template>
        <template v-if="isModNewsEnabled">
            <div class="Divider"></div>
            <ui-subheader id="section-modNews">{{ $t('mediaView.modNewsSubtitle') }}</ui-subheader>
            <div :class="['Panel', {Loading: modNews.uploading}]">
                <div class="Left">
                    <div class="Content">
                        <div class="Upload">
                            <div class="ButtonWrapper">
                                <ui-button @click.native="modNews.dialogVisible = true" type="primary white" :disabled="studio.uploading || studio.loading">
                                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                                    {{ $t('mediaView.modNewsUploadPair') }}
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Right">
                    <ui-loading v-if="notificationImage.loading || iosExtendedNotification.loading" />
                    <ui-scrollbar v-else-if="modNewsSorted.length">
                        <div class="Grid GridToolbarAlt GridSingle">
                            <div
                                v-for="(i, index) in modNewsSorted"
                                class="GridItem"
                                :key="`${i?.android?.id || index}-${i?.ios?.id || index}`"
                                @click="copyToClipboard(i.fileName)"
                            >
                                <div class="Toolbar">
                                    <a href="javascript:;" @click.stop="showModalDelete('modnews', i)">
                                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="17" height="18" viewBox="0 0 17 18" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17 4.112h-1.513l-1.181 13.244a.71.71 0 01-.711.644H3.381a.712.712 0 01-.712-.643L1.488 4.112H0v-1.41h4.976V1.175C4.976.527 5.51 0 6.167 0h4.666c.657 0 1.191.527 1.191 1.175v1.527H17v1.41zM10.595 1.41h-4.19v1.292h4.19V1.41zM2.923 4.112L4.035 16.59h8.906l1.112-12.478H2.923zm7.315 10.384l.31-8.342 1.428.052-.31 8.342-1.428-.052zM7.786 6.18h1.428v8.342H7.786V6.18zm-2.762.026l1.428-.052.309 8.342-1.427.052-.31-8.342z"/></svg>
                                    </a>
                                </div>
                                <div class="ImageWrapper" style="gap: 10px">
                                    <img :src="getNotificationImageSrc(i.android)" style="width: calc(80% - 5px)" v-if="i.android" />
                                    <img :src="getIosExtendedNotificationSrc(i.ios)" style="width: calc(20% - 5px)" v-if="i.ios" />
                                </div>
                                <div class="ItemTitle">
                                    <span>&nbsp;</span>
                                </div>
                            </div>
                        </div>
                    </ui-scrollbar>
                    <span v-else>{{ $t('mediaView.noResults') }}</span>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </div>
            <div class="ModNewsUploadDialog" v-if="modNews.dialogVisible">
                <div class="ModNewsUploadDialogContent">
                    <div class="ModNewsUploadDialogContentPicker">
                        <div>
                            <ui-button @click.native="$refs.modNewsAndroidUploader.click()" type="primary white mb-3" :disabled="modNews.uploading">Android</ui-button>
                            <p>{{ modNews.fileAndroid ? modNews.fileAndroid.name : $t('mediaView.modNewsNoFile') }}</p>
                            <div :class="{Info: true, Error: modNews.error}" v-html="$t('mediaView.modNewsAndroidBody')" />
                        </div>
                        <div>
                            <ui-button @click.native="$refs.modNewsIOSUploader.click()" type="primary white mb-3" :disabled="modNews.uploading">IOS</ui-button>
                            <p>{{ modNews.fileIOS ? modNews.fileIOS.name : $t('mediaView.modNewsNoFile') }}</p>
                            <div :class="{Info: true, Error: modNews.error}" v-html="$t('mediaView.modNewsIOSBody')" />
                        </div>
                    </div>
                    <div class="ModNewsUploadDialogContentActions">
                        <ui-button @click.native="uploadModNewsBackgrounds()" type="primary white" :disabled="modNews.uploading || !modNews.fileAndroid || !modNews.fileIOS">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="13" height="12" viewBox="0 0 13 12" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.717 7.718a.863.863 0 01-1.287 0L7.813 3.807V12H5.188V3.779L1.545 7.718a.863.863 0 01-1.287 0 1.042 1.042 0 010-1.391L5.844.288a.877.877 0 01.644-.289.87.87 0 01.643.289l5.586 6.039a1.04 1.04 0 010 1.391z"/></svg>
                            {{ $t('mediaView.modNewsUpload') }}
                        </ui-button>
                        <ui-button @click.native="modNews.dialogVisible = false; modNews.fileAndroid = null; modNews.fileIOS = null;" type="white" :disabled="modNews.uploading">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="15" height="14.969" viewBox="0 0 15 14.969" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.313 7.452l5.361 5.633c.41.431.41 1.129 0 1.56a1.014 1.014 0 01-1.485 0L7.728 8.906c-.093.029-.187.059-.284.059-.073 0-.143-.028-.215-.044l-5.447 5.724a1.014 1.014 0 01-1.485 0 1.145 1.145 0 010-1.56l5.32-5.59L.279 1.868a1.145 1.145 0 010-1.56 1.01 1.01 0 011.48 0l5.443 5.739c.094-.028.187-.059.283-.059.073 0 .143.028.215.044L13.13.308a1.01 1.01 0 011.48 0 1.147 1.147 0 010 1.56L9.313 7.452z"/></svg>
                            {{ $t('mediaView.modNewsClose') }}
                        </ui-button>
                    </div>
                </div>
            </div>
            <input
                type="file"
                ref="modNewsAndroidUploader"
                name="file"
                accept="*"
                @change="e => pickModNewsBackground(e, 'android')"
                style="display: none"
            />
            <input
                type="file"
                ref="modNewsIOSUploader"
                name="file"
                accept="*"
                @change="e => pickModNewsBackground(e, 'ios')"
                style="display: none"
            />
        </template>
    </ui-container>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.SubNav
    display flex
    flex-wrap wrap
    background #fff
    border 1px solid $cBorder
    margin-bottom 60px
    overflow hidden
    a
        display block
        font-size 12px
        color $cPrimary
        text-transform uppercase
        text-decoration none
        font-weight 700
        display inline-block
        padding 0
        transition .3s all
        width 25%
        text-align center
        border-bottom 1px solid $cBorder
        padding 10px 20px
        box-sizing border-box
        margin-bottom -1px
        position relative
        span
            font-size 1.2em
        &:hover
            color $cAccent
        &:after
            display block
            position absolute
            content ''
            top 25%
            bottom 25%
            right -1px
            width 2px
            background $cAccent
        &:nth-child(4n):after
            display none

.NavTop
    position fixed
    bottom 20px
    right 20px
    width 14px
    height 14px
    background #fff
    border 1px solid $cBorder
    border-radius 50%
    display flex
    align-items center
    justify-content center
    z-index 50
    padding 15px
    fill $cPrimary
    cursor pointer
    transition .3s all
    &:hover
        border-color $cPrimary

.Divider
    background $cBorder
    height 1px
    margin 30px 0

.Panel
    display flex
    background #fff
    border 1px solid $cBorder
    position relative
    overflow hidden
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Loading
        .LoadingOverlay
            transform translate(0,0)
    .Left
        width 35%
        padding 40px
        border-right 1px solid $cBorder
        display flex
        flex-direction column
        .Headline
            margin 0 0 40px
            display none
        .Content
            display flex
            align-items stretch
            flex-grow 1
            .Thumbnail
                margin-right 20px
                .ImageWrapper
                    display flex
                    justify-content center
                    align-items center
                    height 200px
                    width 200px
                    border 1px solid $cBorder
                    box-shadow 0 30px 60px alpha($cPrimary,.1)
                    img
                        height 100%
                        max-width 100%
                        max-height 100%
                    span
                        color $cPrimary
                        font-weight 600
            .Upload
                display flex
                flex-direction column
                font-size 12px
                min-height: 200px
                .Info
                    order 2
                    font-size 15px
                    color $cPrimary
                    &.Error
                        color red
                .ButtonWrapper
                    order 1
                    margin-bottom 30px
    .Right
        width 65%
        padding 40px
        .Grid
            display flex
            justify-content flex-start
            align-items flex-start
            flex-wrap wrap
            border 1px solid $cBorder
            min-height 100%
            margin-bottom 1px
            box-sizing border-box
            .GridItem
                display flex
                flex-direction column
                justify-content center
                align-items center
                width (100% / 3)
                position relative
                border 1px solid $cBorder
                box-sizing border-box
                padding 10px
                .Toolbar
                    display flex
                    justify-content flex-end
                    align-self stretch
                    margin 0px 0 0px
                    top 0
                    left 0
                    right 0
                    .Text
                        flex 1 1 auto
                        overflow hidden
                    a
                        font-size 18px
                        color $cPrimary
                        text-decoration none
                        margin-left 10px
                        transition .3s all
                        path
                            fill $cPrimary
                            transition .3s all
                        &.Error
                            color $cError
                        &:hover, &.Active
                            color $cAccent
                            path
                                fill $cAccent
                .ImageWrapper
                    overflow hidden
                    height 110px
                    display flex
                    justify-content center
                    align-items center
                    position relative
                    &.AddNoise
                        background-image url(/static/img/bg_noise.png)
                        background-size cover
                    img, video
                        max-width 100%
                        max-height 110px
                        height auto
                        width auto
                    iframe
                        border none
                        width 200%
                        height 220px
                        transform scale(.5)
                    .Overlay
                        position absolute
                        top 0
                        right 0
                        bottom 0
                        left 0
                        display flex
                        align-items center
                        justify-content center
                        background rgba(0,0,0,.6)
                        opacity 0
                        transition .3s all
                        padding 8px
                        .OverlayContent
                            padding 8px
                            color $cBg
                            border-radius 5px
                            font-size 10px
                            overflow hidden
                            background #fff
                    &:hover .Overlay
                        opacity 1
                .ItemTitle
                    position relative
                    white-space nowrap
                    overflow hidden
                    max-width 100%
                    width 100%
                    height 12px
                    font-size 10px
                    span
                        position absolute
                        display inline-block
                        top 50%
                        left 50%
                        transform translate(-50%, -50%)
                &:hover .ItemTitle span
                    animation: marquee 6s linear infinite;
            &.GridSingle
                .GridItem
                    width 100%
                    .ImageWrapper
                        width 100%
                        height auto
                        img
                            max-width 100%

    &.AltImageSize
        .Left .Content .Thumbnail .ImageWrapper
            width auto
        .Right .Grid .GridItem .ImageWrapper
            height 235px
        .Right .Grid .GridItem .ImageWrapper img
            max-height 235px
            max-width 95px

.BubbleGroup
    .ImageSelector
        position relative
        margin 0 20px 20px 0
        padding 0 !important
        box-shadow none !important
        border none !important
        align-items center
        .Hint
            display flex
            z-index 99999
            .Popup
                width 400px
                white-space normal
        .Details
            width 65%
            .Thumbnail
                .ImageWrapper
                    display flex
                    justify-content center
                    align-items center
                    height 96px
                    width 96px
                    border 2px solid $cBorder
                    box-shadow 0 10px 20px alpha($cPrimary,.1)
                    img
                        height 100%
                        max-width 100%
                        max-height 100%
                    span
                        color $cPrimary
                        font-weight 600
        .Control
            position relative !important
            width 35%
            .UploadButton
                position absolute
                top 0
                bottom 0
                right 0
                width 64px
                border 3px solid $cBorder
                background lighten($cBorder, 60%)
                display flex
                justify-content center
                align-items center
                transition .3s all
                cursor pointer
                &:hover
                    border-color $cAccent !important
                    background lighten($cAccent, 80%)
        &.StateError .Control .UploadButton
            border-color $cError
            &:hover
                border-color $cError !important

.ApplyInputStyles
    .Input
        margin-top -1px
        box-shadow none !important
        border none !important
        padding 10px 0
        .Control
            position relative
    .UploadButton
        position absolute
        top 0
        bottom 0
        right 0
        width 64px
        border 3px solid $cBorder
        background lighten($cBorder, 60%)
        display flex
        justify-content center
        align-items center
        transition .3s all
        cursor pointer
        &:hover
            border-color $cAccent !important
            background lighten($cAccent, 80%)
    .StateFocus .UploadButton
        border-color $cAccent !important

.ModNewsUploadDialog
    position fixed
    inset 0 0 0 0
    background rgba(255,255,255,.6)
    display flex
    align-items center
    justify-content center
    z-index 10
    .ModNewsUploadDialogContent
        padding 20px
        background #FFF
        border 2px solid #EDEDED
        max-width 640px
        width calc(100% - 80px)
        .ModNewsUploadDialogContentPicker
            display flex
            flex-direction row
            gap 20px
            margin-bottom 20px
            & > div
                flex 1 1 100%
        .ModNewsUploadDialogContentActions
            display flex
            flex-direction row
            justify-content center
            gap 20px


@keyframes marquee {
    0% {
        transform: translate(50%, -50%);
    }
    50% {
        transform: translate(-150%, -50%);
    }
    100% {
        transform: translate(50%, -50%);
    }
}

</style>
